@if (icon) {
<div class="icon-holder">
  <fa-icon [icon]="icon"></fa-icon>
</div>
}
<h6 class="title">
  <ng-content select="[title]"></ng-content>
</h6>
<div class="msg">
  <ng-content select="[msg]"></ng-content>
</div>
<ng-content></ng-content>
